import React, { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { User, Heart, Sparkles, Edit3 } from "lucide-react";

export default function Profile() {
  const { user } = useAuth();
  const { t, lang } = useLang();
  const [profile, setProfile] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data));
  }, []);

  return (
    <div className="space-y-8 max-w-3xl" data-testid="profile-page">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#4A5D23] font-bold">Gracely</p>
        <h1 className="font-serif-display text-4xl text-stone-900 mt-2">{t("profile_title")}</h1>
      </div>

      <div className="card-soft p-8">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-2xl bg-[#4A5D23] text-white flex items-center justify-center text-2xl font-bold">
            {user?.name?.[0]?.toUpperCase() || "G"}
          </div>
          <div>
            <p className="font-serif-display text-2xl text-stone-900">{user?.name}</p>
            <p className="text-stone-500 text-sm">{user?.email}</p>
          </div>
        </div>
      </div>

      <div className="card-soft p-8">
        <div className="flex items-center justify-between">
          <p className="text-xs uppercase tracking-widest text-stone-500 font-bold">{lang === "id" ? "Profil Medis" : "Medical Profile"}</p>
          <Button variant="ghost" onClick={() => nav("/onboarding")} className="text-[#4A5D23]" data-testid="edit-profile-btn">
            <Edit3 className="w-4 h-4 mr-1" /> {t("edit")}
          </Button>
        </div>
        {!profile || !profile.birthdate ? (
          <p className="mt-4 text-stone-500 text-sm">{lang === "id" ? "Profil belum lengkap." : "Profile not completed."}</p>
        ) : (
          <div className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-4">
            <Field label={t("birthdate")} value={profile.birthdate} />
            <Field label={t("age_label")} value={`${computeAgeClient(profile.birthdate)} ${t("years_old")}`} />
            <Field label={t("weight")} value={`${profile.weight_kg} kg`} />
            <Field label={t("height")} value={profile.height_cm ? `${profile.height_cm} cm` : "-"} />
            <Field label={t("activity_level")} value={t(profile.activity_level) || profile.activity_level} />
            <Field label={t("recovery_mode")} value={profile.recovery_mode ? (lang === "id" ? "Ya" : "Yes") : (lang === "id" ? "Tidak" : "No")} />
            <Field label={lang === "id" ? "Kondisi" : "Conditions"} value={(profile.conditions || []).map((c) => t(c) || c).join(", ") || "-"} full />
            <Field label={t("allergies")} value={(profile.allergies || []).join(", ") || "-"} full />
            {profile.conditions_other && <Field label={t("conditions_other_label")} value={profile.conditions_other} full />}
            <Field label={t("notes")} value={profile.notes || "-"} full />
          </div>
        )}
      </div>
    </div>
  );
}

function Field({ label, value, full }) {
  return (
    <div className={full ? "col-span-2 md:col-span-3" : ""}>
      <p className="text-xs uppercase tracking-widest text-stone-500 font-bold">{label}</p>
      <p className="mt-1 text-stone-800">{value}</p>
    </div>
  );
}

function computeAgeClient(bd) {
  if (!bd) return "-";
  try {
    const b = new Date(bd);
    const t = new Date();
    let a = t.getFullYear() - b.getFullYear();
    const m = t.getMonth() - b.getMonth();
    if (m < 0 || (m === 0 && t.getDate() < b.getDate())) a--;
    return a;
  } catch {
    return "-";
  }
}
